import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ConfigServicios } from './config-servicios';
import { Servicio } from 'src/app/models/Servicio/Servicio';
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { EmisorService } from 'src/app/services/emisor.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ImpuestoService } from 'src/app/services/impuesto.service';
import { PermissionService } from 'src/app/services/permission.service';
import { Emisor } from 'src/app/models/Emisor/Emisor';
import Swal from 'sweetalert2';
import { Page } from 'src/app/shared/models/Page';
import { ServicioService } from 'src/app/services/servicios.service';
import { ServicioFilter } from 'src/app/models/Servicio/ServicioFilter';
import { PagedResponse } from 'src/app/shared/models/PagedResponse';
import { SortType } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-mantenedor-servicios',
  templateUrl: './mantenedor-servicios.component.html',
  styleUrls: ['./mantenedor-servicios.component.scss']
})
export class MantenedorServiciosComponent implements OnInit {
  SortType = SortType;
  public loading: boolean = false;
  public rowsMantenedor: Servicio[];
  public configLocal = ConfigServicios;
  public emisorSource: Emisor[];
  private filter: ServicioFilter = new ServicioFilter();
  private closeActionsHandler: any;
  private emisorId: string = this.tokenStorage.getCompany();
  private sucursalId: string = this.tokenStorage.getSubsidiary();
  public superAdm = false;
  public page: Page = new Page();
  public componentStarted: boolean = false;
  private createServiceModal: NgbModalRef;
  private editServiceModal: NgbModalRef;
  private detailsServiceModal: NgbModalRef;
  public selectedService: Servicio = undefined;
  public usuarioId: string;
  @ViewChild("tableMobile") tableRef: any;

  constructor(private modal: NgbModal, private tokenStorage: TokenStorageService, private ref: ChangeDetectorRef, public permissions: PermissionService, private localStorage: LocalStorageService, public utilities: UtilitiesService, private emisorService: EmisorService, private serviciosService: ServicioService)
  {
    this.superAdm = this.tokenStorage.getUser().superAdmin;
    this.usuarioId = this.tokenStorage.getUser().id;
    this.emisorSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
    if (this.superAdm) {
        this.getEmisoresFullList();
    }
  }

  ngOnInit(): void {
    this.filter.emisorId = this.emisorId;
    this.filter.sucursalId = this.sucursalId;
    this.setPage({ offset: 0 });

  }
  setPage(pageInfo, event?) {
    this.loading = true;
    this.page.pageNumber = pageInfo.offset;
    let localPage = JSON.parse(JSON.stringify(this.page));
    localPage.pageNumber += 1;

    this.serviciosService
        .getDataByPage(this.filter, localPage)
        .subscribe(
          (result) => {
              this.rowsMantenedor = result.data as Servicio[];
              this.setPageFromResponse(this.page, result);
          },
          (error) => {
              Swal.fire({
                icon: "error",
                title: "Error en Servicio",
                text: "No ha sido posible obtener la lista de servicios disponibles,favor recargue la página." + this.utilities.setErrorMessageFromArray(error.error),
              });
          }
        )
        .add(() => {
          this.loading = false;
          this.componentStarted = true;
          this.ref.detectChanges();
        });
  }
  searchElementsByFilter(event) {
    let filterLocal = new ServicioFilter();
    this.filter = { ...filterLocal };
    this.filter[event.criterio] = event.busqueda;
    this.filter = this.utilities.clearOtherFilterCriterias(event.criterio, this.filter, this.configLocal);
    this.filter.activo = event.registroActivo;
    this.filter.exento = event.productoExento;
    this.filter.emisorId = event.emisorId ? event.emisorId : this.emisorId;
    this.filter.sucursalId = event.sucursalId ? event.sucursalId : this.sucursalId;
    this.setPage({ offset: 0 });
  }
  setPageFromResponse(currentPage: Page, data: PagedResponse<Servicio>) {
    currentPage.pageSize = data.pageSize;
    currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
    currentPage.totalPages = data.totalPages;
    currentPage.totalElements = data.totalRecords;
  }
  public getTotalPages(rowCount: number, pageSize: number): number {
    if (!pageSize) { 
      return 1; 
    }
    return Math.ceil(rowCount / pageSize);
  }
  setPageSize() {
    //this.page.currentPageSize = this.page.page
    this.setPage({ offset: 0 });
  }
  exportToExcel() {
    this.getAllRowsByFilter(this.page, this.filter);
  }
  
  getAllRowsByFilter(currentPageRef: Page, currentFilter: ServicioFilter) {
    let fullPage: Page = new Page();
    fullPage.pageSize = currentPageRef.totalElements;
    fullPage.pageNumber = 0;
    fullPage.totalElements = currentPageRef.totalElements;
    fullPage.totalPages = 1;
    this.loading = true;
    this.serviciosService.getDataByPage(currentFilter, fullPage).subscribe(
        (result) => {
          let elements = result.data as Servicio[];
          this.ref.detectChanges();
          elements.forEach((row) => {});
          this.loading = false;
          this.ref.detectChanges();
          this.exportExcelData(elements);
        },
        (error) => {
          this.loading = false;
          this.ref.detectChanges();
          Swal.fire({
              icon: "error",
              title: "Error al exportar",
              text: "No es posible exportar los datos. Intente mas tarde. " + this.utilities.setErrorMessageFromArray(error.error),
          });
        },
        () => {
          this.loading = false;
          this.ref.detectChanges();
        }
    );
  }
  exportExcelData(arrayToExport: Array<Servicio>): void {
    let arregloExportar = [];
    arrayToExport.forEach((item) => {
      let elementToExport = {};
      elementToExport["Nombre"] = item.nombre;
      elementToExport["Precio"] = item.precio;
      elementToExport["Exento"] = item.exento ? "Exento" : "Afecto";
      arregloExportar.push(elementToExport);
    });
    this.utilities.exportAsExcelFile(arregloExportar, "Servicios");
  }
  openCreateServiceModal(modalRef) {
    this.createServiceModal = this.modal.open(modalRef, {
        windowClass: "",
        size: "lg",
    });
  }
  openDetailsServiceModal(modalRef, row: Servicio) {
    this.selectedService = row;
    this.detailsServiceModal = this.modal.open(modalRef, {
        windowClass: "",
        size: "",
    });
  }
  openEditServiceModal(modalRef, row: Servicio) {
    this.selectedService = row;
    this.editServiceModal = this.modal.open(modalRef, {
        windowClass: "",
        size: "lg",
    });
  }
  closeCreateModal() {
    this.createServiceModal.close();
  }
  closeDetailsModal() {
    this.selectedService = undefined;
    this.detailsServiceModal.close();
  }
  sendNewServiceOnly(event: Servicio) {
    event.emisorId = this.emisorId;
    event.sucursalId = this.sucursalId;
    event.usuarioCreo = this.usuarioId;
    this.loading = true;
    this.ref.detectChanges();
    this.serviciosService
      .sendServiceRequest(event)
      .subscribe(
        (result) => {
            this.ref.detectChanges();
            this.setPage({ offset: 0 });
            this.ref.detectChanges();
            Swal.fire({
              icon: "success",
              title: "Ingreso de Servicio",
              text: "Se ha guardado el servicio ingresado exitosamente.",
            });
        },
        (error) => {
            Swal.fire({
              icon: "error",
              title: "Error en Servicio",
              text: "No ha sido posible guardar el servicio ingresado, intente nuevamente. " + this.utilities.setErrorMessageFromArray(error.error),
            });
        }
      )
      .add(() => {
        this.loading = false;
        this.closeCreateModal();
        this.ref.detectChanges();
      });
  }
  editServiceRequest(event: Servicio) {
    this.loading = true;
    event.emisorId = this.emisorId;
    event.sucursalId = this.sucursalId;
    event.usuarioModifico = this.usuarioId;
    this.serviciosService
        .editServiceRequest(event)
        .subscribe(
          (result) => {
              let serviceRef = this.rowsMantenedor.find((serv) => serv.servicioId == event.servicioId);
              let index = this.rowsMantenedor.indexOf(serviceRef);
              this.rowsMantenedor.splice(index, 1, event);
              this.rowsMantenedor = [...this.rowsMantenedor];
              this.loading = false;
              Swal.fire({
                icon: "success",
                title: "Edición de Servicio",
                text: "Se han guardado los cambios del servicio exitosamente.",
              });
          },
          (error) => {
              this.loading = false;
              Swal.fire({
                icon: "error",
                title: "Error en Servicio",
                text: "No ha sido posible guardar el servicio editado, intente nuevamente. " + this.utilities.setErrorMessageFromArray(error.error),
              });
          }
        )
        .add(() => {
          this.loading = false;
          this.closeEditModal();
          this.ref.detectChanges();
        });
  }
  deactivateProduct(row: Servicio) {
    this.loading = true;
    this.serviciosService
        .toggle(row.servicioId, false)
        .subscribe(
          (result) => {
              this.ref.detectChanges();
              if (result.data) {
                this.loading = false;
                //row.activo = false;
                this.setPage({ offset: 0 });
                this.ref.detectChanges();
                Swal.fire({
                    icon: "success",
                    title: "Servicio desactivado",
                    text: "El servicio seleccionado ha sido desactivado.",
                });
              }
          },
          (error) => {
              Swal.fire({
                icon: "error",
                title: "Error en Servicio",
                text: "No ha sido posible desactivar el servicio seleccionado, intente nuevamente." + this.utilities.setErrorMessageFromArray(error.error),
              });
          }
        )
        .add(() => {
          this.loading = false;
          this.ref.detectChanges();
        });
  }
  reactivateProduct(row: Servicio) {
    this.loading = true;
    this.serviciosService
        .toggle(row.servicioId, true)
        .subscribe(
          (result) => {
              this.ref.detectChanges();
              if (result.data) {
                this.loading = false;
                //row.activo = true;
                this.setPage({ offset: 0 });
                this.ref.detectChanges();
                Swal.fire({
                    icon: "success",
                    title: "Servicio reactivado",
                    text: "El servicio seleccionado ha sido reactivado.",
                });
              }
          },
          (error) => {
              Swal.fire({
                icon: "error",
                title: "Error en Servicio",
                text: "No ha sido posible reactivar el servicio seleccionado, intente nuevamente." + this.utilities.setErrorMessageFromArray(error.error),
              });
          }
        )
        .add(() => {
          this.loading = false;
          this.ref.detectChanges();
        });
  }
  toggleExpandRow(row) {
    this.tableRef.rowDetail.toggleExpandRow(row);
  }
  toggleActions(row: any): void {
    const newState = !row.showActions;
    this.rowsMantenedor.forEach(r => {
      if (r !== row && r.showActions) {
      r.showActions = false;
      document.removeEventListener('click', this.closeActionsHandler);
      }
    });
    row.showActions = newState;
    if (newState) {
      this.closeActionsHandler = this.closeActionsMenu.bind(this, row);
      setTimeout(() => document.addEventListener('click', this.closeActionsHandler), 0);
    } else {
      document.removeEventListener('click', this.closeActionsHandler);
    }
  }
  closeActionsMenu(row: any, event: MouseEvent): void {
		if (!(event.target as HTMLElement).closest('.action-container')) {
			row.showActions = false;
			this.ref.detectChanges();
			document.removeEventListener('click', this.closeActionsHandler);
		}
	}
  closeEditModal() {
    this.selectedService = undefined;
    this.editServiceModal.close();
  }
  getEmisoresFullList() {
    this.emisorService.getData().subscribe(
        (result) => {
          let emisores = result.data;
          this.emisorSource = emisores;
          this.ref.detectChanges();
        },
        (error) => {
          this.loading = false;
          this.ref.detectChanges();
          Swal.fire({
              icon: "error",
              title: "Error en emisores",
              text: "No fue posible obtener la lista de emisores completa, tiene disponible solamente los emisores ya presentes en el selector de empresas." + this.utilities.setErrorMessageFromArray(error.error),
          });
        }
    );
  }

}
